import { take, call, put, select, fork, cancel } from 'redux-saga/effects';
/**
 * Created by dziamid on 05/07/17.
 */
import { CLOSE_PROMPT_DIALOG } from './constants';
import { closePromptDialog, showPromptDialog, IShowPromptDialogOptions } from './actions';
export function* prompt(message, options: IShowPromptDialogOptions) {
  yield put(showPromptDialog(message, options));
  const { result } = yield take(CLOSE_PROMPT_DIALOG);
  return result;
}
